define([
	"jquery",
	"underscore",
	"backbone",
	"models/quote_model"
], function($, _, Backbone, Quote) {
	return Backbone.View.extend({
		el: '#content_layout',


		events:{
			'click .account_type': function(e){
				if(e) e.preventDefault();

				var type = $(e.currentTarget).data('type');
				if(type){
					this.$el.find('.quote_type').removeClass('active');
					this.$el.find('.ct_nav1 li:first-child a').addClass('active');

					this.accountType =  type;
					//	ECN does not have commodity / index
					if ( type.indexOf('ecn') >= 0) {
						$("a[data-type='commodity']").hide();
						$("a[data-type='index']").hide();
					} else { 
						$("a[data-type='commodity']").show();
						$("a[data-type='index']").show();
					}
					this.getQuotes();
				}
			},
			'click .quote_type': function(e){
				if(e) e.preventDefault();

				var type = $(e.currentTarget).data('type');
				if(type){
					this.$el.find('.quote_type').removeClass('active');
					$(e.currentTarget).addClass('active');

					this.quoteType = type;
					this.getQuotes();
				}
			},
		},

		initialize: function() {
			this.quoteType = 'forex';
			this.accountType = window.default_account_type;
			if ( this.accountType.indexOf('ecn') >= 0) {
				$("a[data-type='commodity']").hide();
				$("a[data-type='index']").hide();
			}

			this.getQuotes();
			this.setTimer();

			// Cache the selector to avoid reading the dom every 1.5s.
			this.$trSelector = $('.quotes_row table tr');

			// this.mainBannerInit();
			this.mainBannerInitForVideo();
            this.mainBannerResizeInit();
		},

		// Recursively calling the set timeout makes sure that we don't have two of them running at the same time.
		setTimer: function(){
			var that = this;
			setTimeout(function(){
				$.when(
					that.getQuotes()
				).done(function(){
					that.setTimer();
				});
			}, 1500);
		},

		getQuotes: function(){
			var that = this;

			var quote = new Quote();
//console.log(quote);
			// Return the fetch promise
			return quote.fetch({
				data: {
					'type' : that.quoteType,
					'promotion': that.accountType,
					't': $.now()
				},
				success: function( model, response, option) {
				//console.log(response);
					that.$trSelector.each(function(index){
						var quote = response.quotes[index];
						$(this).find('.bid').html(quote.bid);
						$(this).find('.ask').html(quote.ask);
						$(this).find('.symbol').html(quote.symbol);
						$(this).find('.spread').html(quote.spread);
					});
				},
				fail: function( model, response, option) {
				console.log(response);
				},
			});
		},

		// Slide for use video
        mainBannerInitForVideo: function(){
            var that = this;
            var $myCarousel = this.$el.find('#myCarousel');
            var $items = $myCarousel.find('.item');

            this.slideItems = [];
            $items.each(function(idx, $item){
                $item = $($item);

				/*
				 Start direction from bottom or top in have item_list : bottom_to_top | top_to_bottom
				 */
                var posDirection = '';
                $item.find('.item_list').attr('class').split(' ').forEach(function (className, idx){
                    if(/^(bottom|top)_\w+(top|bottom)$/.test(className)){
                        posDirection = className;
                        return false;
                    }
                });

				/*
				 Flect indicator icon in frame center
				 */
                var _indicatorIcon = $('<li data-target="#myCarousel" data-slide-to="' + idx + '"></li>');
                if(idx===0) _indicatorIcon.addClass('active');
                $myCarousel.find('ol.carousel-indicators').append(_indicatorIcon);

				/*
				 Make backgroundImage Use by have bg of class and remove image dom
				 */
                $item.css({
                    'background-image' : 'url('+$item.find('img.bg').attr('src')+')'
                });

				/*
				 Make animation position use by image data
				 */
                var config = {
                    container_height : $myCarousel.height(),
                    bg_color : $item.find('img.bg').attr('data-slide-bg-color'),
                    item : []
                }
                $item.find('img:not(.bg)').each(function(idx, img){
                    img = $(img);
                    config.item.push({
                        top : img.attr('data-slide-top')+'px',
                        left : img.attr('data-slide-left')+'px'
                    });

                    //Make Image link
                    if(img.attr('data-link')){
                        img.css('cursor','pointer');
                        img.click(function(){
                            if( $(this).attr('data-target') != undefined ){
                                window.open($(this).attr('data-link'), $(this).attr('data-target'));
                            }
                            else {
                                location.href = $(this).attr('data-link');
                            }
                        });
                    }
                });


                that.slideItems[idx] = {
                    item : $item,
                    config : config,
                    posDirection : posDirection
                }

                $item.find('img.bg').remove();
            });

            $myCarousel.bind('slide.bs.carousel', function(e){
                var active = $(e.target).find('.carousel-inner > .item.active');
                var next = $(e.relatedTarget);

                that.slideCurrentIdx = active.index();
                that.slideNextIdx = next.index();
                that.slideDirection = e.direction;

                // that.resetSlideLayout(that.slideCurrentIdx);
            });

            $myCarousel.on('slid.bs.carousel', function (e) {
                that.resetSlideLayout(that.slideCurrentIdx);
                that.makeSlideLayout(that.slideNextIdx);
            });
            this.makeSlideLayout();
		},

		// Slide for background image
		mainBannerInit : function(){
			var that = this;
			var $myCarousel = this.$el.find('#myCarousel');
			var $items = $myCarousel.find('.item');

			this.slideItems = [];
			$items.each(function(idx, $item){
				$item = $($item);

				/*
				Start direction from bottom or top in have item_list : bottom_to_top | top_to_bottom
				 */
				var posDirection = '';
				$item.find('.item_list').attr('class').split(' ').forEach(function (className, idx){
					if(/^(bottom|top)_\w+(top|bottom)$/.test(className)){
						posDirection = className;
						return false;
					}
				});

				/*
				Flect indicator icon in frame center
				 */
				var _indicatorIcon = $('<li data-target="#myCarousel" data-slide-to="' + idx + '"></li>');
				if(idx===0) _indicatorIcon.addClass('active');
				$myCarousel.find('ol.carousel-indicators').append(_indicatorIcon);

				/*
				Make backgroundImage Use by have bg of class and remove image dom
				 */
				$item.css({
					'background-image' : 'url('+$item.find('img.bg').attr('src')+')'
				});

				/*
				Make animation position use by image data
				 */
				var config = {
					container_height : $myCarousel.height(),
					bg_color : $item.find('img.bg').attr('data-slide-bg-color'),
					item : []
				}
				$item.find('img:not(.bg)').each(function(idx, img){
					img = $(img);
					config.item.push({
						top : img.attr('data-slide-top')+'px',
						left : img.attr('data-slide-left')+'px'
					});

					//Make Image link
					if(img.attr('data-link')){
						img.css('cursor','pointer');
						img.click(function(){
							location.href = $(this).attr('data-link');
						});
					}
				});

				that.slideItems[idx] = {
					item : $item,
					config : config,
					posDirection : posDirection
				}

				$item.find('img.bg').remove();
			});

			$myCarousel.bind('slide.bs.carousel', function(e){
				var active = $(e.target).find('.carousel-inner > .item.active');
				var next = $(e.relatedTarget);

				that.slideCurrentIdx = active.index();
				that.slideNextIdx = next.index();
				that.slideDirection = e.direction;

				that.resetSlideLayout(that.slideCurrentIdx);
			});

			$myCarousel.on('slid.bs.carousel', function (e) {
				that.makeSlideLayout(that.slideNextIdx);
			});
			this.makeSlideLayout();

		},

		makeSlideLayout : function(idx){
			idx = !!idx ? idx : 0;

			var that = this;

			this.$el.find('#myCarousel').animate({
				'background-color' : this.slideItems[idx].config.bg_color,
			},'fast').css({
				'border-top' : (this.slideItems[idx].config.border_top_color) ? 'inset 1px ' + this.slideItems[idx].config.border_top_color : 'none'
			});

			this.slideItems[idx].item.find('img').each(function(i, img){
				img = $(img);
				var config = that.slideItems[idx].config.item[i];

				var imgConfig = { left : config.left }
				if(that.slideItems[idx].posDirection=='bottom_to_top') {
					imgConfig.top = (that.slideItems[idx].config.container_height + img.height()) + 'px';
				} else {
					imgConfig.top = - (that.slideItems[idx].config.container_height + img.height()) + 'px';
				}
				img.css(imgConfig);

				var delay = 200;
				img.delay(delay*(i)).animate(config, 'slow');
			});
		},

		resetSlideLayout : function(idx){
			idx = !!idx ? idx : 0;
			if(idx<0) return false;

			var that = this;

			this.slideItems[idx].item.find('img').each(function(i, img){
				img = $(img);
				var config = that.slideItems[idx].config.item[i];
				var delay = 50;

				var imgConfig = {}
				if(that.slideItems[idx].posDirection=='bottom_to_top') {
					//imgConfig.top = '200%';
					imgConfig.top = (that.slideItems[idx].config.container_height + img.height()) + 'px';
				} else {
					//imgConfig.top = '-100%';
					imgConfig.top = - (that.slideItems[idx].config.container_height + img.height()) + 'px';
				}

				$(img).delay(delay*(i+1)).animate(imgConfig, 'fast');
			});
		},

        mainBannerResizeInit: function() {
            $(window).on("resize", this.mainBannerResize);
            this.mainBannerResize();
		},

        mainBannerResize: function() {
            var wRatio = 1.777;
			var youtubeContainer = $('#myCarousel .youtube_bg');
            var youtubeVideo = youtubeContainer.find('video');

			var width = youtubeContainer.width();
			var height = youtubeVideo.width() / wRatio;

            youtubeVideo.width(width);
            youtubeVideo.height(height);
            // this.youtubeVideo.css({
            	// 'top': height / 2
			// });
		},

	});
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/main/index_view.js
// module id = 29
// module chunks = 0